import React from 'react';
import { Jumbotron as Jumbo } from 'react-bootstrap';
import { Container, Row, Col, Button } from 'reactstrap';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Card } from 'react-bootstrap';

import preConference1 from '../../assets/images/contents/01-azlan.png';
import preConference2 from '../../assets/images/contents/02-dr-syed.png';
import preConference3 from '../../assets/images/contents/03-Dr-Sayang.png';
import preConference4 from '../../assets/images/contents/04-DedyDwiPrastyo.png';
import preConference5 from '../../assets/images/contents/05-achmad.png';

export const PreConference = () => (
    <div>
        <br/> 
        <Container>
            <Row>
                <Col></Col>
                <Col></Col>

                <Col>
                    <Card style={{ width: '20rem', maxWidth: '100%' , height:'auto'}} className="zoomBOut">
                        <TransformWrapper>
                            <TransformComponent>
                                <Card.Img variant="top" src={preConference1} className="zoomBIn"/>
                            </TransformComponent>
                        </TransformWrapper>
                        
                        <Card.Body>
                        <Card.Title>
                            <Button style={{justifyContent:'space-around'}} href={preConference1} target="_blank" download rel="noopener noreferrer">Download Poster</Button> </Card.Title>
                        
                        <Card.Text>  
                            <a href="/"> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
                            <a href="/">Click this link to register:  </a>
                            <a href="https://bit.ly/DESL2021" target="_blank"> https://bit.ly/DESL2021</a>
                        </Card.Text>
                        </Card.Body>                
                    </Card>
                </Col>
               
                <Col>
                    <Card style={{ width: '20rem', maxWidth: '100%', height:'auto'}} className="zoomBOut">
                        <TransformWrapper>
                                <TransformComponent>
                                <Card.Img variant="top" src={preConference2} className="zoomBIn"/>
                                </TransformComponent>
                        </TransformWrapper>

                        <Card.Body>
                        <Card.Title> <Button style={{justifyContent:'space-around'}} href={preConference2} target="_blank" download rel="noopener noreferrer">Download Poster</Button></Card.Title>
                        <Card.Text> 
                            <a href="/"> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
                            <a href="/">Click this link to register:  </a>
                            <a href="https://bit.ly/DLUP2021" target="_blank"> https://bit.ly/DLUP2021</a>
                        </Card.Text>
                        </Card.Body>
                    </Card>    
                </Col>

                <Col></Col>
                <Col></Col>
            </Row>           

        <br/>
       
            <Row>
                <Col></Col>

                <Col>             
                    <Card style={{ width: '20rem', maxWidth: '100%', height:'auto'}} className="zoomBOut">
                        <TransformWrapper>
                            <TransformComponent>
                            <Card.Img variant="top" src={preConference3} className="zoomBIn"/>
                            </TransformComponent>
                        </TransformWrapper>

                        <Card.Body>
                        <Card.Title><Button style={{justifyContent:'space-around'}} href={preConference3} target="_blank" download rel="noopener noreferrer">Download Poster</Button> </Card.Title>
                        <Card.Text>   
                            <a href="/"> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
                            <a href="/">Click this link to register:  </a>
                            <a href="https://bit.ly/DMAR2021" target="_blank" rel="noreferrer"> https://bit.ly/DMAR2021</a>
                        </Card.Text>
                        </Card.Body>
                    </Card>               
                </Col>                      

                <Col>
                    <Card style={{ width: '20rem', maxWidth: '100%', height:'auto'}} className="zoomBOut">
                        <TransformWrapper>
                            <TransformComponent>
                            <Card.Img variant="top" src={preConference4} className="zoomBIn"/>
                            </TransformComponent>
                        </TransformWrapper>

                        <Card.Body>
                        <Card.Title> <Button style={{justifyContent:'space-around'}} href={preConference4} target="_blank" download rel="noopener noreferrer">Download Poster</Button></Card.Title>
                        <Card.Text>  
                            <a href="/"> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
                            <a href="/">Click this link to register:  </a>
                            <a href="https://bit.ly/TSML2021" target="_blank" rel="noreferrer"> https://bit.ly/TSML2021</a>
                        </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card style={{ width: '20rem', maxWidth: '100%', height:'auto'}} className="zoomBOut">
                        <TransformWrapper>
                            <TransformComponent>
                            <Card.Img variant="top" src={preConference5} className="zoomBIn"/>
                            </TransformComponent>
                        </TransformWrapper>

                        <Card.Body>
                        <Card.Title> <Button style={{justifyContent:'space-around'}} href={preConference5} target="_blank" download rel="noopener noreferrer">Download Poster</Button></Card.Title>
                        <Card.Text>  
                            <a href="/"> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
                            <a href="/">Click this link to register:  </a>
                            <a href="https://bit.ly/SSUR2021" target="_blank" rel="noreferrer"> https://bit.ly/SSUR2021</a>
                        </Card.Text>
                        </Card.Body>
                    </Card> 
                </Col>

                <Col></Col>

            </Row>
        </Container>
                             
    </div>
)

//   <Styles>
//         <br/>
//     <Carousel pause = 'hover' className = "carousel">
//             <Carousel.Item interval={9000} >
//                   <a href = "https://bit.ly/DESL2021" target="_blank" rel="noopener noreferrer">
//                         <img className = "img"
                        
//                         src={preConference1}
//                         alt="Dr Azlan"
//                         width="100%"
//                         height="100%"   
//                         />
//                   </a>
//             <Carousel.Caption>
//             </Carousel.Caption>
//             </Carousel.Item>

//             <Carousel.Item interval={9000}>
//                   <a href = "https://bit.ly/DLUP2021" target="_blank" rel="noopener noreferrer">
//                         <img

//                         src={preConference2}
//                         alt="Dr Syed"
//                         width="100%"
//                         height="100%"
//                         />
//                   </a>
//             <Carousel.Caption>
//             </Carousel.Caption>
//             </Carousel.Item>

//             <Carousel.Item interval={9000}>
//                   <a href = "https://bit.ly/DMAR2021" target="_blank" rel="noopener noreferrer">
//                         <img

//                         src={preConference3}
//                         alt="Dr Sayang"
//                         width="100%"
//                         height="100%x"
//                         />
//                   </a>
//             <Carousel.Caption>
//             </Carousel.Caption>
//             </Carousel.Item>

//             <Carousel.Item interval={9000}>
//                   <a href = "https://bit.ly/TSML2021" target="_blank" rel="noopener noreferrer">
//                         <img

//                         src={preConference4}
//                         alt="Prof Dedy"
//                         width="100%"
//                         height="100%"
//                         />
//                   </a>
//             <Carousel.Caption>
//             </Carousel.Caption>
//             </Carousel.Item>

//             <Carousel.Item interval={9000}>
//                   <a href = "https://bit.ly/SSUR2021" target="_blank" rel="noopener noreferrer">
//                         <img

//                         src={preConference5}
//                         alt="Dr Achmad"
//                         width="100%"
//                         height="100%"
//                         />
//                   </a>
//             <Carousel.Caption>
//             </Carousel.Caption>
//             </Carousel.Item>

//     </Carousel>
//   </Styles>


{/* <Container>
<Row xs="2" sm="2" md="3">
    <Col></Col>

    <Col>
        <Card style={{ width: '25rem', maxWidth: '100%' , height:'auto'}} className="zoomBOut">
            <TransformWrapper>
                <TransformComponent>
                    <Card.Img variant="top" src={preConference1} className="zoomBIn"/>
                </TransformComponent>
            </TransformWrapper>
            
            <Card.Body>
            <Card.Title>
                <Button style={{justifyContent:'space-around'}} href={preConference1} target="_blank" download rel="noopener noreferrer">Download Poster</Button> </Card.Title>
            
            <Card.Text>  
                <a> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
                <a>Click this link to register:  </a>
                <a href="https://bit.ly/DESL2021" target="_blank"> https://bit.ly/DESL2021</a>
            </Card.Text>
            </Card.Body>                
        </Card>
    </Col>
   
    <Col>
    <Card style={{ width: '25rem', maxWidth: '100%', height:'auto'}}>
        <TransformWrapper>
                <TransformComponent>
                <Card.Img variant="top" src={preConference2} className="zoomBIn"/>
                </TransformComponent>
        </TransformWrapper>

        <Card.Body>
        <Card.Title> <Button style={{justifyContent:'space-around'}} href={preConference2} target="_blank" download rel="noopener noreferrer">Download Poster</Button></Card.Title>
        <Card.Text> 
            <a> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
            <a>Click this link to register:  </a>
            <a href="https://bit.ly/DLUP2021" target="_blank"> https://bit.ly/DLUP2021</a>
        </Card.Text>
        </Card.Body>
    </Card>    
    </Col>
    <Col></Col>
    <Col></Col>
</Row>           
</Container> */}


{/* <div className = "row" style={{justifyContent: 'space-between'}}>
{/* <Col></Col> 

<div className = "column">
    <Card style={{ width: '25rem', maxWidth: '100%' , height:'auto'}} className="zoomBOut">
        <TransformWrapper>
            <TransformComponent>
                <Card.Img variant="top" src={preConference1} className="zoomBIn"/>
            </TransformComponent>
        </TransformWrapper>
        
        <Card.Body>
        <Card.Title>
            <Button style={{justifyContent:'space-around'}} href={preConference1} target="_blank" download rel="noopener noreferrer">Download Poster</Button> </Card.Title>
        
        <Card.Text>  
            <a> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
            <a>Click this link to register:  </a>
            <a href="https://bit.ly/DESL2021" target="_blank"> https://bit.ly/DESL2021</a>
        </Card.Text>
        </Card.Body>                
    </Card>
</div>

<div className = "column">
<Card style={{ width: '25rem', maxWidth: '100%', height:'auto'}}>
    <TransformWrapper>
            <TransformComponent>
            <Card.Img variant="top" src={preConference2} className="zoomBIn"/>
            </TransformComponent>
    </TransformWrapper>

    <Card.Body>
    <Card.Title> <Button style={{justifyContent:'space-around'}} href={preConference2} target="_blank" download rel="noopener noreferrer">Download Poster</Button></Card.Title>
    <Card.Text> 
        <a> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
        <a>Click this link to register:  </a>
        <a href="https://bit.ly/DLUP2021" target="_blank"> https://bit.ly/DLUP2021</a>
    </Card.Text>
    </Card.Body>
</Card>    
</div>

{/* <Col></Col>
<Col></Col> 
</div>           

<br/>

<div className = "row" style={{justifyContent: 'space-between'}}>
<div className = "column">             
<Card style={{ width: '25rem', maxWidth: '100%', height:'auto'}}>
    <TransformWrapper>
        <TransformComponent>
        <Card.Img variant="top" src={preConference3} className="zoomBIn"/>
        </TransformComponent>
    </TransformWrapper>

    <Card.Body>
    <Card.Title><Button style={{justifyContent:'space-around'}} href={preConference3} target="_blank" download rel="noopener noreferrer">Download Poster</Button> </Card.Title>
    <Card.Text>   
        <a> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
        <a>Click this link to register:  </a>
        <a href="https://bit.ly/DMAR2021" target="_blank"> https://bit.ly/DMAR2021</a>
    </Card.Text>
    </Card.Body>
</Card>               
</div>

<div className = "column">
<Card style={{ width: '25rem', maxWidth: '100%', height:'auto'}}>
    <TransformWrapper>
        <TransformComponent>
        <Card.Img variant="top" src={preConference4} className="zoomBIn"/>
        </TransformComponent>
    </TransformWrapper>

    <Card.Body>
    <Card.Title> <Button style={{justifyContent:'space-around'}} href={preConference4} target="_blank" download rel="noopener noreferrer">Download Poster</Button></Card.Title>
    <Card.Text>  
        <a> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
        <a>Click this link to register:  </a>
        <a href="https://bit.ly/TSML2021" target="_blank"> https://bit.ly/TSML2021</a>
    </Card.Text>
    </Card.Body>
</Card>
</div>

<div className = "column">
<Card style={{ width: '25rem', maxWidth: '100%', height:'auto'}}>
    <TransformWrapper>
        <TransformComponent>
        <Card.Img variant="top" src={preConference5} className="zoomBIn"/>
        </TransformComponent>
    </TransformWrapper>

    <Card.Body>
    <Card.Title> <Button style={{justifyContent:'space-around'}} href={preConference5} target="_blank" download rel="noopener noreferrer">Download Poster</Button></Card.Title>
    <Card.Text>  
        <a> Use mouse scroll to zoom in and zoom out the image.</a><br/><br/>
        <a>Click this link to register:  </a>
        <a href="https://bit.ly/SSUR2021" target="_blank"> https://bit.ly/SSUR2021</a>
    </Card.Text>
    </Card.Body>
</Card> 
</div>
       
</div>          */}